import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/panelSelection'


export function getOne(code,id) {
    return request({
        url:`${BASE_REQUEST}/getOne`,
        data: {
            code:code,
            id:id
        }
    })
}

export function quickSave(code,quickName) {
    return request({
        url:`${BASE_REQUEST}/quickSave`,
        data: {
            code:code,
            quickName:quickName
        }
    })
}

export function saveRecord(key,datakey) {
    return request({
        url:`${BASE_REQUEST}/saveRecord`,
        data: {
            key:key,
            datakey:datakey
        }
    })
}


export function getCommonAndRecordByKey(key) {
    return request({
        url:`${BASE_REQUEST}/getCommonAndRecordByKey`,
        data: {
            key:key
        }
    })
}


export function getList(key,name) {
    return request({
        url:`${BASE_REQUEST}/getList`,
        data: {
            code:key,
            queryName:name
        }
    })
}

export function getCommonAndRecordBeanByKey(key) {
    return request({
        url:`${BASE_REQUEST}/getCommonAndRecordBeanByKey`,
        data: {
            code:key
        }
    })
}
